import { LazyLoad } from '@common/vanilla_ui/general';

function initialize() {
  new LazyLoad({
    callback(entry) {
      const { target } = entry;
      target.src = target.dataset.src;
      target.classList.remove(this.selector);
      if (target.tagName === 'DOTLOTTIE-PLAYER') {
        try {
          target.load(target.dataset.src);
        } catch {
          // Do Nothing
        }
      }
      this.observer.unobserve(target);
    },
  });
}

export default { initialize };
